<template>
	<div id="copyright">
		2012 - {{ thisYear }} &copy; Bell Oldow, Inc. All Rights Reserved. <span style="margin:0 5px">|</span> Software Developed by <a href="https://www.trevnetmedia.com" title="Custom Software development" target="_blank" style="color: #888; text-decoration: none">TrevNet</a>
	</div>
</template>
<script>

export default {
	data () {
		return {
			thisYear: new Date().getFullYear()
		}
	}
}
</script>
